import { styled, Typography } from "@mui/material";
import { Checkbox } from "@volt_developers/components";

import { TEST_IDS } from "constants/TestIds";

import type Region from "models/Region";
import type { ReactNode, SyntheticEvent } from "react";

export interface RegionLabelProps {
  id: Region["regionCode"];
  label: ReactNode;
  isSelected: boolean;
  isIndeterminate: boolean;
  onClick: (event: SyntheticEvent) => void;
}

export function RegionLabel({
  id,
  label,
  isSelected,
  isIndeterminate,
  onClick,
}: RegionLabelProps) {
  const testId = TEST_IDS.getCheckbox(String(id));

  return (
    <>
      <Arrow />
      <StyledCheckbox
        id={testId}
        data-testid={testId}
        checked={isSelected}
        indeterminate={isIndeterminate}
        onClick={onClick}
      />
      <Typography variant="h7" color="text.high">
        {label}
      </Typography>
    </>
  );
}

const Arrow = styled("div")(({ theme }) => ({
  width: 0,
  height: 0,
  borderTop: "5px solid transparent",
  borderBottom: "5px solid transparent",
  borderLeft: `5px solid ${theme.palette.text.high}`,
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(2),
}));

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  minWidth: 20,
  marginRight: theme.spacing(1.5),
}));
